export enum SmsAppModals {
  START_CONVERSATION = 'start-conversation',
}
